import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { Dialog, DialogContent } from './ui/dialog';

const STORAGE_KEY = 'salkantay_promo_seen';
const SCROLL_THRESHOLD = 0.2; // 20% de la página

function alreadyShownThisVisit() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function markShownThisVisit() {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // sessionStorage no disponible (navegación privada, etc.) - sin problema,
    // en el peor caso puede volver a aparecer en la misma visita.
  }
}

const WeeklyPromoPopup = () => {
  const [promo, setPromo] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    fetch('/api/weekly_promo.php')
      .then((res) => res.json())
      .then((data) => {
        if (data.exists) setPromo(data);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!promo || alreadyShownThisVisit()) return undefined;

    function handleScroll() {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollable > 0 ? window.scrollY / scrollable : 1;

      if (progress >= SCROLL_THRESHOLD) {
        setOpen(true);
        markShownThisVisit();
        window.removeEventListener('scroll', handleScroll);
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [promo]);

  if (!promo) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        hideClose
        className="max-w-[92vw] w-auto p-0 border-none bg-transparent shadow-none overflow-visible"
        data-testid="weekly-promo-popup"
      >
        <div className="relative inline-block">
          <img
            src={promo.url}
            alt="Promoción de la semana"
            className="max-w-[85vw] max-h-[80vh] w-auto h-auto rounded-2xl shadow-2xl block mx-auto"
          />
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="absolute -top-3 -right-3 rounded-full p-1.5 bg-white shadow-lg text-coffee hover:bg-cream transition-colors"
            aria-label="Cerrar"
            data-testid="weekly-promo-close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WeeklyPromoPopup;
